import { config } from '@js/index';

export default class LV2GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LV2GameScene' });
  }

  init() {
    this.questionNumber = 0;
    this.orangeArray = [];
    this.orangeArray1 = [];
    this.orangeArray2 = [];
    this.correctAnsOnes = '';
    this.correctAnsTens = '';
    this.correctAnsHundreds = '';
    this.correct = false;
    this.points = [];
    this.points1 = [];
    this.points2 = [];
    this.inputSelectionCode = 0;
  }

  preload() {}

  create() {
    this.cameras.main.fadeIn(1000, 255, 255, 255);

    this.createAnimationFrames();

    this.lv2_gameSceneBG = this.add
      .sprite(0, 0, 'lv2_gameSceneBG')
      .setOrigin(0)
      .setVisible(true);
    this.lv2_gameSceneBGTop = this.add
      .sprite(0, 0, 'lv2_gameSceneBGTop')
      .setOrigin(0, 1)
      .setVisible(true);

    this.lv2_cloud = this.add.image(1400, 100, 'cloud');

    this.birdAnim = this.add.sprite(0, 0, 'birdFly').setOrigin(0).setVisible(true);
    this.birdAnim.play('makebirdsfly');

    config.audio.BoxAppearingOnTruck = this.sound
      .add('BoxAppearingOnTruck')
      .setVolume(0.1);
    config.audio.BoxComingOut = this.sound.add('BoxComingOut').setVolume(0.1);
    config.audio.orangeOnConveyor = this.sound.add('orangeOnConveyor').setVolume(0.1);
    config.audio.IncorrectAnswer = this.sound.add('IncorrectAnswer').setVolume(0.1);
    config.audio.CorrectAnswer = this.sound.add('CorrectAnswer').setVolume(0.1);
    config.audio.LogoReveal = this.sound.add('LogoReveal').setVolume(0.1);
    config.audio.harvesterRunning = this.sound.add('harvesterRunning').setVolume(0.08);
    config.audio.largetruckdriveoff = this.sound
      .add('large-truck-drive-off')
      .setVolume(0.5);

    // cloud movement
    this.tweens.add({
      targets: this.lv2_cloud,
      x: -200,
      duration: 90000,
      ease: 'Power1',
      repeat: -1,
      yoyo: true,
    });

    this.lv2_machine = this.add
      .sprite(346 - 2.5, 139.94 - 2, 'lv2_machine')
      .setOrigin(0)
      .setVisible(true);

    this.lv2_leftTruck = this.add
      .sprite(-397, 205, 'lv2_leftTruck')
      .setOrigin(0)
      .setVisible(true);
    this.lv2_rightTruck = this.add
      .sprite(1001, 184, 'lv2_rightTruck')
      .setOrigin(0)
      .setVisible(true);

    this.createOrange();

    this.lv2_leftTruckCover = this.add
      .sprite(-170.75, 237.39, 'lv2_leftTruckCover')
      .setOrigin(0)
      .setVisible(true);
    this.lv2_leftTruckWheels = this.add
      .sprite(81.09 - 2.31, 490.21 - 2.31, 'lv2_singleWheel')
      .setOrigin(0)
      .setVisible(true);

    this.boxOnTruckDepth0_1 = this.add
      .sprite(1015, 323, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth0_2 = this.add
      .sprite(1015, 323 - 65.5 * 1, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth0_3 = this.add
      .sprite(1015, 323 - 65.5 * 2, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth0_4 = this.add
      .sprite(1015, 323 - 65.5 * 3, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);

    this.boxOnTruckDepth1_1 = this.add
      .sprite(1015 + 55, 323 + 20, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth1_2 = this.add
      .sprite(1015 + 55, 323 + 20 - 65.5 * 1, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth1_3 = this.add
      .sprite(1015 + 55, 323 + 20 - 65.5 * 2, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);
    this.boxOnTruckDepth1_4 = this.add
      .sprite(1015 + 55, 323 + 20 - 65.5 * 3, 'boxAnim')
      .setOrigin(0)
      .setVisible(false);

    this.boxOnTruckDepth0_Array = [
      this.boxOnTruckDepth0_1,
      this.boxOnTruckDepth0_2,
      this.boxOnTruckDepth0_3,
      this.boxOnTruckDepth0_4,
    ];
    this.boxOnTruckDepth1_Array = [
      this.boxOnTruckDepth1_1,
      this.boxOnTruckDepth1_2,
      this.boxOnTruckDepth1_3,
      this.boxOnTruckDepth1_4,
    ];

    this.lv2_rightTruckCover = this.add
      .sprite(1152.23, 219.08, 'lv2_rightTruckCover')
      .setOrigin(0)
      .setVisible(true);
    this.lv2_rightTruckWheels = this.add
      .sprite(1131.99 - 2.5, 492.95 - 2.5, 'lv2_singleWheel')
      .setOrigin(0)
      .setVisible(true);

    this.lv2_pack = this.add
      .sprite(556, 502, 'lv2_pack')
      .setOrigin(0)
      .setVisible(false)
      .setInteractive({ cursor: 'pointer' });

    this.leftContainer = this.add.container(-200, 0, [
      this.lv2_leftTruck,
      ...this.orangeArray,
      ...this.orangeArray1,
      ...this.orangeArray2,
      this.lv2_leftTruckCover,
      this.lv2_leftTruckWheels,
    ]);
    this.rightContainer = this.add.container(200, 0, [
      this.lv2_rightTruck,
      ...this.boxOnTruckDepth0_Array,
      ...this.boxOnTruckDepth1_Array,
      this.lv2_rightTruckCover,
      this.lv2_rightTruckWheels,
    ]);

    this.lv2_grass = this.add
      .sprite(-124, 599, 'lv2_grass')
      .setOrigin(0)
      .setVisible(true)
      .setDepth(1);

    this.lv2_ones = this.add
      .sprite(687.95, 406 - 100, 'default')
      .setOrigin(0)
      .setAlpha(0);
    this.lv2_onesCursor = this.add
      .sprite(687.95 + 27, 406.53 + 6 - 100, 'cursor')
      .setOrigin(0)
      .setVisible(false);
    this.lv2_onesText = this.add
      .text(687.95 + 27, 406.53 + 24 - 100, '', {
        fontFamily: 'font2',
        fontSize: '50px',
        fill: '#2B2B2B',
      })
      .setOrigin(0.5, 0.5)
      .setVisible(true);

    this.lv2_tens = this.add
      .sprite(625.75, 406 - 100, 'default')
      .setOrigin(0)
      .setAlpha(0);
    this.lv2_tensCursor = this.add
      .sprite(625.75 + 27, 406.53 + 6 - 100, 'cursor')
      .setOrigin(0)
      .setVisible(false);
    this.lv2_tensText = this.add
      .text(625.75 + 27, 406.53 + 24 - 100, '', {
        fontFamily: 'font2',
        fontSize: '50px',
        fill: '#2B2B2B',
      })
      .setOrigin(0.5, 0.5)
      .setVisible(true);

    this.lv2_hundreds = this.add
      .sprite(562.95, 406 - 100, 'default')
      .setOrigin(0)
      .setAlpha(0);
    this.lv2_hundredsCursor = this.add
      .sprite(562.95 + 27, 406.53 + 6 - 100, 'cursor')
      .setOrigin(0)
      .setVisible(false);
    this.lv2_hundredsText = this.add
      .text(562.95 + 27, 406.53 + 24 - 100, '', {
        fontFamily: 'font2',
        fontSize: '50px',
        fill: '#2B2B2B',
      })
      .setOrigin(0.5, 0.5)
      .setVisible(true);

    this.lv2_question = this.add.sprite(559, 365, 'lv2_qn1').setOrigin(0).setAlpha(0);

    this.lv2_bulb1 = this.add
      .sprite(596 - 12, 170.21 - 15, 'bulb')
      .setOrigin(0)
      .setVisible(false);
    this.lv2_bulb2 = this.add
      .sprite(596 - 12 + 42, 170.21 - 15, 'bulb')
      .setOrigin(0)
      .setVisible(false);
    this.lv2_bulb3 = this.add
      .sprite(596 - 12 + 84, 170.21 - 15, 'bulb')
      .setOrigin(0)
      .setVisible(false);

    this.conveyorAnim = this.add
      .sprite(0, 0, 'conveyorAnim')
      .setOrigin(0)
      .setVisible(true);

    this.orangeStack1 = this.add
      .sprite(339, 445, 'orange01Anim')
      .setOrigin(0)
      .setVisible(false);
    this.orangeStack2 = this.add
      .sprite(339, 410, 'orange02Anim')
      .setOrigin(0)
      .setVisible(false);
    this.orangeStack3 = this.add
      .sprite(339, 370, 'orange01Anim')
      .setOrigin(0)
      .setVisible(false);
    this.orangeStack4 = this.add
      .sprite(339, 330, 'orange02Anim')
      .setOrigin(0)
      .setVisible(false);
    this.orangeStack5 = this.add
      .sprite(339, 280, 'orange01Anim')
      .setOrigin(0)
      .setVisible(false);

    this.machineStack = this.add.container(0, 0, [
      this.lv2_machine,
      this.conveyorAnim,
      this.lv2_question,
      this.lv2_ones,
      this.lv2_tens,
      this.lv2_hundreds,
      this.lv2_onesCursor,
      this.lv2_tensCursor,
      this.lv2_hundredsCursor,
      this.lv2_onesText,
      this.lv2_tensText,
      this.lv2_hundredsText,
      this.orangeStack1,
      this.orangeStack2,
      this.orangeStack3,
      this.orangeStack4,
      this.orangeStack5,
      this.lv2_bulb1,
      this.lv2_bulb2,
      this.lv2_bulb3,
      this.lv2_pack,
    ]);

    this.unitBox1 = this.add
      .sprite(782 - 128, 484, 'lv2_unitBox')
      .setOrigin(0)
      .setVisible(false);
    this.unitBox2 = this.add
      .sprite(782 - 128, 423, 'lv2_unitBox')
      .setOrigin(0)
      .setVisible(false);
    this.unitBox3 = this.add
      .sprite(782 - 128, 362, 'lv2_unitBox')
      .setOrigin(0)
      .setVisible(false);
    this.unitBox4 = this.add
      .sprite(782 - 128, 301, 'lv2_unitBox')
      .setOrigin(0)
      .setVisible(false);

    this.leftMaskImage = this.add
      .image(312, 276, 'lv2_mask')
      .setVisible(false)
      .setOrigin(0);
    this.rightMaskImage = this.add
      .image(790, 276, 'lv2_mask')
      .setVisible(false)
      .setOrigin(0);
    this.leftMask = this.leftMaskImage.createBitmapMask();
    this.rightMask = this.rightMaskImage.createBitmapMask();

    this.orangeStack1.setMask(this.leftMask);
    this.orangeStack2.setMask(this.leftMask);
    this.orangeStack3.setMask(this.leftMask);
    this.orangeStack4.setMask(this.leftMask);
    this.orangeStack5.setMask(this.leftMask);

    this.unitBox1.setMask(this.rightMask);
    this.unitBox2.setMask(this.rightMask);
    this.unitBox3.setMask(this.rightMask);
    this.unitBox4.setMask(this.rightMask);

    this.conveyorBoxStacks = [this.unitBox1, this.unitBox2, this.unitBox3, this.unitBox4];

    this.confettiAnim = this.add
      .sprite(30, -200, 'confettiAnim')
      .setOrigin(0)
      .setVisible(true);

    this.textInputController();
    this.keypadInput();

    this.flash1 = this.plugins
      .get('rexflashplugin')
      .add(this.lv2_onesCursor, { duration: 700, repeat: 1000 });
    this.flash2 = this.plugins
      .get('rexflashplugin')
      .add(this.lv2_tensCursor, { duration: 700, repeat: 1000 });
    this.flash3 = this.plugins
      .get('rexflashplugin')
      .add(this.lv2_hundredsCursor, { duration: 700, repeat: 1000 });

    this.handlePackButton();

    this.changequestion();
  }

  // ==================== FLOW ====================

  clearBay() {
    config.audio.harvesterRunning.stop();
    config.audio.largetruckdriveoff.setVolume(0.5);
    config.audio.largetruckdriveoff.play();

    this.tweens.add({
      targets: config.audio.largetruckdriveoff,
      volume: 0,
      delay: 500,
      duration: 1500,
    });

    if (this.questionNumber > 2) {
      this.tweens.add({
        targets: this.leftContainer,
        x: { value: -400, duration: 1500, repeat: 0 },
      });

      this.time.delayedCall(750, () => {
        this.moveToEndScene();
      });
    }

    this.tweens.add({
      targets: this.rightContainer,
      x: { value: 400, duration: 1500, repeat: 0 },
      onComplete: () => {
        this.tweens.add({
          targets: [
            this.lv2_question,
            this.lv2_onesText,
            this.lv2_tensText,
            this.lv2_hundredsText,
            this.lv2_ones,
            this.lv2_tens,
            this.lv2_hundreds,
          ],
          alpha: { value: 0, duration: 500, repeat: 0 },
          onComplete: () => {
            if (this.questionNumber <= 2) {
              this.clearCursor();
              this.changequestion();
            } else {
              this.clearCursor();
            }
          },
        });
      },
    });
  }

  moveToEndScene() {
    this.cameras.main.pan(1280 / 2, -720 / 2, 5000, 'Power2');

    this.time.delayedCall(1500, () => {
      this.cameras.main.fadeOut(1000, 255, 255, 255);
    });

    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.stop('LV2GameScene');
      this.scene.start('LV2EndScene');
    });
  }

  askQuestion() {
    this.clearCursor();

    this.orangeStack1.x = 339;
    this.orangeStack2.x = 339;
    this.orangeStack3.x = 339;
    this.orangeStack4.x = 339;
    this.orangeStack5.x = 339;

    this.unitBox1.setPosition(782 - 128, 484);
    this.unitBox2.setPosition(782 - 128, 423);
    this.unitBox3.setPosition(782 - 128, 362);
    this.unitBox4.setPosition(782 - 128, 301);

    this.orangeStack1.setVisible(false);
    this.orangeStack2.setVisible(false);
    this.orangeStack3.setVisible(false);
    this.orangeStack4.setVisible(false);
    this.orangeStack5.setVisible(false);

    this.boxOnTruckDepth0_1.setVisible(false).setFrame(0);
    this.boxOnTruckDepth0_2.setVisible(false).setFrame(0);
    this.boxOnTruckDepth0_3.setVisible(false).setFrame(0);
    this.boxOnTruckDepth0_4.setVisible(false).setFrame(0);

    this.boxOnTruckDepth1_1.setVisible(false).setFrame(0);
    this.boxOnTruckDepth1_2.setVisible(false).setFrame(0);
    this.boxOnTruckDepth1_3.setVisible(false).setFrame(0);
    this.boxOnTruckDepth1_4.setVisible(false).setFrame(0);

    config.audio.largetruckdriveoff.setVolume(0.5);
    config.audio.largetruckdriveoff.play();

    this.tweens.add({
      targets: config.audio.largetruckdriveoff,
      volume: 0,
      delay: 500,
      duration: 1500,
    });

    if (this.questionNumber === 2 || this.questionNumber === 3) {
      this.tweens.add({
        targets: [this.lv2_hundreds],
        alpha: { value: 1, duration: 1000, repeat: 0 },
        delay: 1500,
      });
    }

    this.tweens.add({
      targets: [
        this.lv2_question,
        this.lv2_onesText,
        this.lv2_tensText,
        this.lv2_hundredsText,
        this.lv2_tens,
        this.lv2_ones,
      ],
      alpha: { value: 1, duration: 1000, repeat: 0 },
      delay: 1500,
      onComplete: () => {
        config.audio.harvesterRunning.play();
      },
    });

    this.tweens.add({
      targets: [this.leftContainer, this.rightContainer],
      y: { start: -2, to: 2, duration: 300, repeat: -1, yoyo: true },
      x: { value: 0, duration: 1500, repeat: 0 },
    });

    if (this.questionNumber === 1) {
      this.tweens.add({
        targets: [this.leftContainer, this.rightContainer],
        y: { start: -2, to: 2, duration: 300, repeat: -1, yoyo: true },
        x: { value: 0, duration: 1500, repeat: 0 },
      });
    } else if (this.questionNumber === 2 || this.questionNumber === 3) {
      this.tweens.add({
        targets: this.rightContainer,
        y: { start: -2, to: 2, duration: 300, repeat: -1, yoyo: true },
        x: { value: 0, duration: 1500, repeat: 0 },
      });
    }

    this.time.delayedCall(1500, () => {
      if (this.questionNumber === 1) {
        this.unloadOranges(1);
        this.lv2_pack.setVisible(true);
        this.stackOranges1_3_5(1, 300);
        this.enableDisableInputs(0);
      } else if (this.questionNumber === 2) {
        this.unloadOranges(2);
        this.lv2_pack.setVisible(true);
        this.stackOranges1_3_5(3, 300);
        this.enableDisableInputs(0);
      } else if (this.questionNumber === 3) {
        this.unloadOranges(3);
        this.lv2_pack.setVisible(true);
        this.stackOranges1_3_5(5, 300);
        this.enableDisableInputs(0);
      }
    });
  }

  runConveyor(firststacklength, secondstacklength) {
    this.conveyorAnim.play('moveconveyor');

    this.tweens.add({
      targets: [
        this.orangeStack1,
        this.orangeStack2,
        this.orangeStack3,
        this.orangeStack4,
        this.orangeStack5,
      ],
      x: { start: 339, to: 485 },
      ease: 'Cubic',
      duration: 1500,
      repeat: 0,
      yoyo: false,
      completeDelay: 0,
      onComplete: () => {
        this.releaseBox(firststacklength, 0);

        this.time.delayedCall(2500, () => {
          this.unitBox1.setPosition(782 - 128, 484);
          this.unitBox2.setPosition(782 - 128, 423);
          this.unitBox3.setPosition(782 - 128, 362);
          this.unitBox4.setPosition(782 - 128, 301);
          this.releaseBox(secondstacklength, 1);
        });

        this.time.delayedCall(5500, () => {
          this.clearBay();
        });
      },
    });
  }

  releaseBox(code, depthintruck) {
    this.conveyorAnim.play('moveconveyor');
    config.audio.BoxComingOut.play();

    if (code === 3) {
      this.unitBox1.setVisible(true);
      this.unitBox2.setVisible(true);
      this.unitBox3.setVisible(true);
      this.unitBox4.setVisible(false);
    } else if (code === 4) {
      this.unitBox1.setVisible(true);
      this.unitBox2.setVisible(true);
      this.unitBox3.setVisible(true);
      this.unitBox4.setVisible(true);
    }

    this.tweens.add({
      targets: this.conveyorBoxStacks,
      x: { start: 654, to: 782 },
      ease: 'Cubic',
      duration: 1600,
      repeat: 0,
      yoyo: false,
      completeDelay: 0,
      onComplete: () => {
        if (depthintruck === 0) {
          if (code === 3) {
            this.boxOnTruckDepth0_1.setVisible(true);
            this.boxOnTruckDepth0_2.setVisible(true);
            this.boxOnTruckDepth0_3.setVisible(true);
            this.boxOnTruckDepth0_4.setVisible(false);
          } else if (code === 4) {
            this.boxOnTruckDepth0_1.setVisible(true);
            this.boxOnTruckDepth0_2.setVisible(true);
            this.boxOnTruckDepth0_3.setVisible(true);
            this.boxOnTruckDepth0_4.setVisible(true);
          }
          let i = 3;
          const interval1 = setInterval(() => {
            config.audio.BoxAppearingOnTruck.play();
            this.conveyorBoxStacks[i].setVisible(false);
            this.boxOnTruckDepth0_Array[3 - i].play('finishedbox');
            i--;
            if (i === -1) clearInterval(interval1);
          }, 150);
        } else if (depthintruck === 1) {
          if (code === 3) {
            this.boxOnTruckDepth1_1.setVisible(true);
            this.boxOnTruckDepth1_2.setVisible(true);
            this.boxOnTruckDepth1_3.setVisible(true);
            this.boxOnTruckDepth1_4.setVisible(false);
          } else if (code === 4) {
            this.boxOnTruckDepth1_1.setVisible(true);
            this.boxOnTruckDepth1_2.setVisible(true);
            this.boxOnTruckDepth1_3.setVisible(true);
            this.boxOnTruckDepth1_4.setVisible(true);
          }
          let k = 3;
          const interval2 = setInterval(() => {
            config.audio.BoxAppearingOnTruck.play();
            this.conveyorBoxStacks[k].setVisible(false);
            this.boxOnTruckDepth1_Array[3 - k].play('finishedbox');
            k--;
            if (k === -1) clearInterval(interval2);
          }, 150);
        }
      },
    });
  }

  handlePackButton() {
    this.lv2_pack.on('pointerover', () => {
      this.lv2_pack.setTexture('lv2_packHover');
    });
    this.lv2_pack.on('pointerout', () => {
      this.lv2_pack.setTexture('lv2_pack');
    });
    this.lv2_pack.on('pointerup', () => {
      this.evaluateKeypadInput();
    });
  }

  evaluateKeypadInput() {
    this.correct = false;
    this.inputSelectionCode = 0;

    if (
      this.questionNumber === 1 &&
      (this.lv2_hundredsText.text === '0' ||
        this.lv2_hundredsText.text === this.correctAnsHundreds) &&
      this.lv2_tensText.text === this.correctAnsTens &&
      this.lv2_onesText.text === this.correctAnsOnes
    ) {
      this.correct = true;
    } else if (
      this.questionNumber === 2 &&
      (this.lv2_hundredsText.text === '0' ||
        this.lv2_hundredsText.text === this.correctAnsHundreds) &&
      this.lv2_tensText.text === this.correctAnsTens &&
      this.lv2_onesText.text === this.correctAnsOnes
    ) {
      this.correct = true;
    } else if (
      this.questionNumber === 3 &&
      this.lv2_hundredsText.text === this.correctAnsHundreds &&
      this.lv2_tensText.text === this.correctAnsTens &&
      this.lv2_onesText.text === this.correctAnsOnes
    ) {
      this.correct = true;
    }

    if (this.lv2_hundredsText.text === '') this.lv2_hundreds.setTexture('default');
    if (this.lv2_tensText.text === '') this.lv2_tens.setTexture('default');
    if (this.lv2_onesText.text === '') this.lv2_ones.setTexture('default');

    this.flash1.stop();
    this.flash2.stop();
    this.flash3.stop();

    this.lv2_onesCursor.setVisible(false);
    this.lv2_tensCursor.setVisible(false);
    this.lv2_hundredsCursor.setVisible(false);

    this.lv2_bulb1.setTexture('bulb');
    this.lv2_bulb2.setTexture('bulb');
    this.lv2_bulb3.setTexture('bulb');

    if (this.correct) {
      this.enableDisableInputs(1);
      this.lv2_pack.setVisible(false);

      if (this.lv2_hundredsText.text !== '') {
        this.lv2_hundredsText.setFill('#149A53');
        this.lv2_hundreds.setTexture('correct');
      }
      if (this.lv2_tensText.text !== '') {
        this.lv2_tensText.setFill('#149A53');
        this.lv2_tens.setTexture('correct');
      }
      if (this.lv2_onesText.text !== '') {
        this.lv2_onesText.setFill('#149A53');
        this.lv2_ones.setTexture('correct');
      }

      this.correctAnswerFlow();

      this.time.delayedCall(1000, () => {
        if (this.questionNumber === 1) this.runConveyor(3, 3);
        else if (this.questionNumber === 2) this.runConveyor(4, 4);
        else if (this.questionNumber === 3) this.runConveyor(4, 3);
      });
    } else {
      this.incorrectAnswerFlow();

      if (this.lv2_hundredsText.text !== '') {
        this.lv2_hundredsText.setFill('#C22300');
        this.lv2_hundreds.setTexture('wrong');
      }
      if (this.lv2_tensText.text !== '') {
        this.lv2_tensText.setFill('#C22300');
        this.lv2_tens.setTexture('wrong');
      }
      if (this.lv2_onesText.text !== '') {
        this.lv2_onesText.setFill('#C22300');
        this.lv2_ones.setTexture('wrong');
      }
    }
  }

  correctAnswerFlow() {
    this.confettiAnim.play('confettipop');
    config.audio.CorrectAnswer.play();

    if (this.questionNumber === 1) this.lv2_bulb1.setVisible(true);
    else if (this.questionNumber === 2) this.lv2_bulb2.setVisible(true);
    else if (this.questionNumber === 3) this.lv2_bulb3.setVisible(true);
  }

  incorrectAnswerFlow() {
    config.audio.IncorrectAnswer.play();

    this.tweens.add({
      targets: this.machineStack,
      x: { start: -1.5, to: 1.5 },
      ease: 'Linear',
      duration: 50,
      repeat: 10,
      yoyo: true,
      onComplete: () => {
        this.clearCursor();
        this.lv2_onesText.setText('');
        this.lv2_tensText.setText('');
        this.lv2_hundredsText.setText('');
      },
    });
  }

  enableDisableInputs(code) {
    if (code === 0) {
      this.lv2_ones.setInteractive({ cursor: 'pointer' });
      this.lv2_tens.setInteractive({ cursor: 'pointer' });
      this.lv2_hundreds.setInteractive({ cursor: 'pointer' });
    } else if (code === 1) {
      this.lv2_ones.removeInteractive();
      this.lv2_tens.removeInteractive();
      this.lv2_hundreds.removeInteractive();
    }
  }

  textInputController() {
    this.lv2_ones.on('pointerup', () => {
      this.inputSelectionCode = 1;
      this.clickOnInputbox();
    });
    this.lv2_tens.on('pointerup', () => {
      this.inputSelectionCode = 2;
      this.clickOnInputbox();
    });
    this.lv2_hundreds.on('pointerup', () => {
      this.inputSelectionCode = 3;
      this.clickOnInputbox();
    });
  }

  clearCursor() {
    this.flash1.stop();
    this.flash2.stop();
    this.flash3.stop();
    this.lv2_onesCursor.setVisible(false);
    this.lv2_tensCursor.setVisible(false);
    this.lv2_hundredsCursor.setVisible(false);
    this.lv2_ones.setTexture('default');
    this.lv2_tens.setTexture('default');
    this.lv2_hundreds.setTexture('default');
    this.lv2_onesText.setFill('#2B2B2B');
    this.lv2_tensText.setFill('#2B2B2B');
    this.lv2_hundredsText.setFill('#2B2B2B');
  }

  clickOnInputbox() {
    this.clearCursor();
    if (this.inputSelectionCode === 1 && this.lv2_onesText.text === '')
      this.flash1.flash();
    else if (this.inputSelectionCode === 2 && this.lv2_tensText.text === '')
      this.flash2.flash();
    else if (this.inputSelectionCode === 3 && this.lv2_hundredsText.text === '')
      this.flash3.flash();

    if (this.inputSelectionCode === 1) this.lv2_ones.setTexture('typing');
    else if (this.inputSelectionCode === 2) this.lv2_tens.setTexture('typing');
    else if (this.inputSelectionCode === 3) this.lv2_hundreds.setTexture('typing');
  }

  keypadInput() {
    this.input.keyboard.on(
      'keydown',
      event => {
        if (this.inputSelectionCode === 1) {
          this.lv2_onesText.setText(parseInt(event.key, 10));
          this.lv2_onesText.setVisible(true);
          this.lv2_ones.setTexture('typing');
          if (this.lv2_onesText.text.length === 0) this.lv2_onesText.setFill('#2B2B2B');
        } else if (this.inputSelectionCode === 2) {
          this.lv2_tensText.setText(parseInt(event.key, 10));
          this.lv2_tensText.setVisible(true);
          this.lv2_tens.setTexture('typing');
          if (this.lv2_tensText.text.length === 0) this.lv2_tensText.setFill('#2B2B2B');
        } else if (this.inputSelectionCode === 3) {
          this.lv2_hundredsText.setText(parseInt(event.key, 10));
          this.lv2_hundredsText.setVisible(true);
          this.lv2_hundreds.setTexture('typing');
          if (this.lv2_hundredsText.text.length === 0)
            this.lv2_hundredsText.setFill('#2B2B2B');
        }
        this.manageBlink();
      },
      this,
    );
  }

  manageBlink() {
    this.flash1.stop();
    this.flash2.stop();
    this.flash3.stop();
    this.lv2_onesCursor.setVisible(false);
    this.lv2_tensCursor.setVisible(false);
    this.lv2_hundredsCursor.setVisible(false);

    if (this.inputSelectionCode === 1 && this.lv2_onesText.text === '')
      this.flash1.flash();
    else if (this.inputSelectionCode === 2 && this.lv2_tensText.text === '')
      this.flash2.flash();
    else if (this.inputSelectionCode === 3 && this.lv2_hundredsText.text === '')
      this.flash3.flash();
  }

  changequestion() {
    this.questionNumber += 1;

    this.lv2_onesText.setText('');
    this.lv2_tensText.setText('');
    this.lv2_hundredsText.setText('');

    if (this.questionNumber === 1) {
      this.correctAnsOnes = '6';
      this.correctAnsTens = '1';
      this.correctAnsHundreds = '';

      this.lv2_question.setTexture('lv2_qn1');

      this.lv2_tens.setPosition(625.75 - 7, 406 - 100);
      this.lv2_tensCursor.setPosition(625.75 + 27 - 7, 406.53 + 6 - 100);
      this.lv2_tensText.setPosition(625.75 + 27 - 7, 406.53 + 24 - 100);

      this.lv2_ones.setPosition(687.95 - 9, 406 - 100);
      this.lv2_onesCursor.setPosition(687.95 + 27 - 9, 406.53 + 6 - 100);
      this.lv2_onesText.setPosition(687.95 + 27 - 9, 406.53 + 24 - 100);
    } else if (this.questionNumber === 2) {
      this.correctAnsOnes = '5';
      this.correctAnsTens = '4';
      this.correctAnsHundreds = '';
      this.lv2_question.setTexture('lv2_qn2').setPosition(552, 365);

      this.lv2_hundreds.setPosition(562.95 + 35 - 2, 406 - 100);
      this.lv2_hundredsCursor.setPosition(564.95 + 35 + 27 - 5, 406.53 + 6 - 100);
      this.lv2_hundredsText.setPosition(564.95 + 35 + 27 - 3, 406.53 + 24 - 100);

      this.lv2_tens.setPosition(625.75 - 7 + 29 - 0.2, 406 - 100);
      this.lv2_tensCursor.setPosition(625.75 + 27 - 7 + 29 - 2, 406.53 + 6 - 100);
      this.lv2_tensText.setPosition(625.75 + 27 - 7 + 29, 406.53 + 24 - 100);

      this.lv2_ones.setPosition(687.95 - 7 + 18, 406 - 100);
      this.lv2_onesCursor.setPosition(687.95 + 27 - 7 + 18 - 2, 406.53 + 6 - 100);
      this.lv2_onesText.setPosition(687.95 + 27 - 7 + 18, 406.53 + 24 - 100);

      this.lv2_hundreds.setScale(0.95, 1);
      this.lv2_tens.setScale(0.95, 1);
      this.lv2_ones.setScale(0.95, 1);
    } else if (this.questionNumber === 3) {
      this.correctAnsOnes = '0';
      this.correctAnsTens = '0';
      this.correctAnsHundreds = '6';
      this.lv2_question.setTexture('lv2_qn3').setPosition(542, 365);

      this.lv2_hundreds.setPosition(562.95 + 35 - 2 + 12 + 15, 406 - 100);
      this.lv2_hundredsCursor.setPosition(564.95 + 35 + 27 + 4 + 15, 406.53 + 6 - 100);
      this.lv2_hundredsText.setPosition(564.95 + 35 + 27 + 5 + 15, 406.53 + 24 - 100);

      this.lv2_tens.setPosition(625.75 - 7 + 29 + 7.7 + 15, 406 - 100);
      this.lv2_tensCursor.setPosition(625.75 + 27 - 7 + 29 + 3 + 15, 406.53 + 6 - 100);
      this.lv2_tensText.setPosition(625.75 + 27 - 7 + 29 + 4 + 15, 406.53 + 24 - 100);

      this.lv2_ones.setPosition(687.95 - 7 + 18 + 4 + 15, 406 - 100);
      this.lv2_onesCursor.setPosition(687.95 + 27 - 7 + 18 + 15, 406.53 + 6 - 100);
      this.lv2_onesText.setPosition(687.95 + 27 - 7 + 18 + 1 + 15, 406.53 + 24 - 100);

      this.lv2_hundreds.setScale(0.85, 1);
      this.lv2_tens.setScale(0.85, 1);
      this.lv2_ones.setScale(0.85, 1);
    }
    this.askQuestion();
  }

  createAnimationFrames() {
    this.anims.create({
      key: 'orange1unload',
      frames: this.anims.generateFrameNames('orange01Anim', {
        start: 0,
        end: 32,
        zeroPad: 0,
        prefix: 'OrangeTypeA',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'orange2unload',
      frames: this.anims.generateFrameNames('orange02Anim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'OrangeTypeB',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'moveconveyor',
      frames: this.anims.generateFrameNames('conveyorAnim', {
        start: 0,
        end: 29,
        zeroPad: 0,
        prefix: 'Conveyor',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'finishedbox',
      frames: this.anims.generateFrameNames('boxAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'Box',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'confettipop',
      frames: this.anims.generateFrameNames('confettiAnim', {
        start: 0,
        end: 78,
        zeroPad: 0,
        prefix: 'confetti',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    // birdFly anim already created in StartScene; only re-create if missing.
    if (!this.anims.exists('makebirdsfly')) {
      this.anims.create({
        key: 'makebirdsfly',
        frames: this.anims.generateFrameNames('birdFly', {
          start: 0,
          end: 369,
          zeroPad: 0,
          prefix: 'birdsAnim',
          suffix: '.png',
        }),
        frameRate: 25,
        repeat: -1,
      });
    }
  }

  createOrange() {
    const rect = new Phaser.Geom.Rectangle(-101, 213, 275, 105);
    const tri1 = new Phaser.Geom.Triangle(186, 214, 186, 462, 250, 462);
    const tri2 = new Phaser.Geom.Triangle(186, 214, 250, 214, 250, 462);

    while (this.points.length < 100) {
      this.points.push(rect.getRandomPoint());
    }
    for (let i = 0; i < this.points.length; i++) {
      const p = this.points[i];
      this.orangeArray[i] = this.add
        .sprite(p.x, p.y, 'lv2_orange')
        .setAngle(Phaser.Math.Between(0, 360))
        .setScale(Phaser.Math.Between(5, 10) / 10)
        .setDepth(1)
        .setOrigin(0.5);
    }

    while (this.points1.length < 60) {
      this.points1.push(tri1.getRandomPoint());
    }
    for (let i = 0; i < this.points1.length; i++) {
      const q = this.points1[i];
      this.orangeArray1[i] = this.add
        .sprite(q.x, q.y, 'lv2_orange')
        .setAngle(Phaser.Math.Between(0, 360))
        .setScale(Phaser.Math.Between(5, 10) / 10)
        .setDepth(1);
    }

    while (this.points2.length < 60) {
      this.points2.push(tri2.getRandomPoint());
    }
    for (let i = 0; i < this.points2.length; i++) {
      const r = this.points2[i];
      this.orangeArray2[i] = this.add
        .sprite(r.x, r.y, 'lv2_orange')
        .setAngle(Phaser.Math.Between(0, 360))
        .setScale(Phaser.Math.Between(5, 10) / 10)
        .setDepth(1);
    }
  }

  unloadOranges(code) {
    if (code === 1) {
      let i = 59;
      const interval = setInterval(() => {
        this.orangeArray2[i].setVisible(false);
        i--;
        if (i === -1) clearInterval(interval);
      }, 5);
    } else if (code === 2) {
      let i = 59;
      const interval = setInterval(() => {
        this.orangeArray1[i].setVisible(false);
        i--;
        if (i === -1) clearInterval(interval);
      }, 15);
    } else if (code === 3) {
      let i = 99;
      const interval = setInterval(() => {
        this.orangeArray[i].setVisible(false);
        i--;
        if (i === -1) clearInterval(interval);
      }, 15);
    }
  }

  stackOranges1_3_5(height, delay) {
    if (height === 1) {
      this.time.delayedCall(1, () => {
        this.orangeStack1.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
    } else if (height === 3) {
      this.time.delayedCall(delay, () => {
        this.orangeStack1.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(1 * delay, () => {
        this.orangeStack2.play('orange2unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(2 * delay, () => {
        this.orangeStack3.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
    } else if (height === 5) {
      this.time.delayedCall(1, () => {
        this.orangeStack1.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(1 * delay, () => {
        this.orangeStack2.play('orange2unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(2 * delay, () => {
        this.orangeStack3.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(3 * delay, () => {
        this.orangeStack4.play('orange2unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
      this.time.delayedCall(4 * delay, () => {
        this.orangeStack5.play('orange1unload').setVisible(true);
        config.audio.orangeOnConveyor.play();
      });
    }
  }

  update() {}
}
